<template>
  <v-app>
    <toolbar></toolbar>

    <loading />
    <snackbar />

    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import toolbar from "@/components/Toolbar";
import loading from "@/components/Loading";
import snackbar from "@/components/Snackbar";

export default {
  components: {
    loading,
    toolbar,
    snackbar
  },
  mounted() {
    window.onpopstate = event => {
      if (localStorage.getItem("token") == null) {
        this.$router.push("/");
      }
    };
  }
};
</script>
